import {useCallback, useEffect, useRef} from "react";

export const TEXTAREA_AUTO_GROW_MAX_H = 100;
export const TEXTAREA_AUTO_GROW_MIN_H = 38;
export const TEXTAREA_REMARK_MIN_H = 80;

export function useAutoResizeTextarea(
    value,
    {minHeight = TEXTAREA_AUTO_GROW_MIN_H, maxHeight = TEXTAREA_AUTO_GROW_MAX_H, externalRef} = {},
) {
    const internalRef = useRef(null);
    const ref = externalRef ?? internalRef;

    const syncHeight = useCallback(() => {
        const el = ref.current;
        if (!el) return;

        el.style.height = "auto";
        const scrollHeight = el.scrollHeight;
        const nextHeight = Math.min(maxHeight, Math.max(minHeight, scrollHeight));
        el.style.setProperty("height", `${nextHeight}px`, "important");
        el.style.setProperty("min-height", `${minHeight}px`, "important");
        el.style.overflowY = scrollHeight > maxHeight ? "auto" : "hidden";
    }, [ref, minHeight, maxHeight]);

    useEffect(() => {
        syncHeight();
    }, [value, syncHeight]);

    return {ref, syncHeight};
}
